import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../../shared/theme/useColorScheme";

interface MobileDeviceStatusCardStyles {
  container: ICSSInJSStyle;
  deviceIcon: ICSSInJSStyle;
  deviceTypeName: ICSSInJSStyle;
  selectedDevice: ICSSInJSStyle;
}

export const useMobileDeviceStatusCardStyles: () => MobileDeviceStatusCardStyles =
  () => {
    const { white, grey } = useFluentColorScheme();
    return {
      container: {
        minHeight: "52px",
      },
      deviceIcon: {
        color: white.foreground,
        height: "20px",
        width: "20px",
      },
      deviceTypeName: {
        color: white.foreground,
      },
      selectedDevice: {
        color: grey.foreground2,
      },
    };
  };
